module.exports = __webpack_public_path__ + "static/plain-medium-0685b979c35d8b4fc9bb4134427828fc.otf";